import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import Plan from "./Plan";
import settings from "./swipeSettings";
import planType from "./types/planType";
import { Wrapper, TermsInfo, TermsLink } from "./styles/monthly-styles";
import { NoPlansAvailableText } from "./styles/shared-styles";

const MonthlyPlansList = ({ monthly, termsMonthly }) => (
  <Wrapper>
    {monthly.length > 0 ? (
      <>
        <Slider {...settings(monthly.length)}>
          {monthly.map((plan, index) => (
            <Plan
              key={plan.id}
              {...plan}
              plansCount={monthly.length}
              index={index}
              paymentFrequency="monthly"
            />
          ))}
        </Slider>
        <TermsInfo
          className="animated fadeIn delay"
          data-test-id="terms-of-business"
        >
          {termsMonthly} Read the{" "}
          <TermsLink
            href="https://www.hiring-hub.com/termsofbusiness/"
            rel="noopener noreferrer"
            target="_blank"
            data-test-id="terms-link"
          >
            Terms of business
          </TermsLink>
          .
        </TermsInfo>
      </>
    ) : (
      <NoPlansAvailableText>
        Please contact your account manager to discuss our monthly plan options.
      </NoPlansAvailableText>
    )}
  </Wrapper>
);

MonthlyPlansList.propTypes = {
  monthly: PropTypes.arrayOf(planType).isRequired,
  termsMonthly: PropTypes.string,
  toggleTermsModal: PropTypes.func.isRequired,
};

MonthlyPlansList.defaultProps = {
  termsMonthly: PropTypes.isNull,
};

export default MonthlyPlansList;
